
import { toast } from '@/hooks/use-toast';
import { ScheduledNotification, SCHEDULED_NOTIFICATIONS_KEY } from './types';

/**
 * Get scheduled notifications from localStorage
 */
export const getScheduledNotificationsFromStorage = (): ScheduledNotification[] => {
  const stored = localStorage.getItem(SCHEDULED_NOTIFICATIONS_KEY);
  if (!stored) return [];
  
  try {
    return JSON.parse(stored);
  } catch (error) {
    console.error('Failed to parse scheduled notifications from localStorage:', error);
    return [];
  }
};

/**
 * Save scheduled notifications to localStorage
 */
export const saveScheduledNotificationsToStorage = (notifications: ScheduledNotification[]): void => {
  try {
    localStorage.setItem(SCHEDULED_NOTIFICATIONS_KEY, JSON.stringify(notifications));
  } catch (error) {
    console.error('Failed to save scheduled notifications to localStorage:', error);
    toast({
      title: 'Storage Error',
      description: 'Failed to save scheduled notifications to browser storage',
      variant: 'destructive'
    });
  }
};

/**
 * Generate a UUID for notification IDs
 */
export const generateUUID = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};
